// Bulgarian translations
const translations = {
  // Navigation
  dashboard: "Табло",
  excavators: "Машини",
  reports: "Доклади",
  users: "Потребители",
  profile: "Профил",
  logout: "Излизане",
  login: "Вход",
  register: "Регистрация",
  management: "Управление",
  analytics: "Анализи",
  hello: "Здравейте",
  maintenanceReportSystem: "Система за Доклади за Поддръжка",
  changeLanguage: "Смяна на езика",

  // Dashboard Specific
  dashboardSubtitle: " Verwalten Sie Ihre Baumaschinen und Wartungsberichte effizient",
  setLastMaintenanceDate: " Поставете дата на последната поддръжка",
  todaysDate: " Heutiges Datum",
  Saturday: " Събота",
  Sunday: " Неделя",
  Monday: " Понеделник",
  Tuesday: " Вторник",
  Wednesday: " Сряда",
  Thursday: " Четвъртък",
  Friday: " Петък",
  notesAndObservations: " Notizen und Beobachtungen",
  Dashboard: " Табло", // Capitalized version
  welcomeBack: " Добре дошли отново",
  selectLanguage: " Избор на език",
  createNewReport: " Създаване на нов доклад",
  viewAllReports: " Преглед на всички доклади",
  fromLastMonth: " От миналия месец",
  requiresAttention: " Изисква внимание",
  lastSixMonths: " Последните шест месеца",
  noRecentReports: " Няма скорошни доклади",
  noPendingReports: " Няма чакащи доклади",
  inspection: " Инспекция",
  recentReports: " Скорошни доклади",
  viewDetails: " Преглед на детайли",
  personnel: " Персонал",
  entryDetails: " Детайли на записа",
  viewReports: " Преглед на доклади",
  viewAllUsers: " Преглед на всички потребители",
  items: " Елементи",
  refreshing: " Опресняване...",
  reportStatus: " Статус на доклада",
  allSigned: " Всички доклади са подписани",
  excellent: " Отлично",
  active: " Активен",
  signedby: " Подписан от",
  excavatorHealth: " Здраве на машината",
  needsAttention: " Нуждае се от внимание",
  healthScore: " Здравен рейтинг",
  noExcavatorData: " Няма налични данни за машината",
  noOperatorData: " Няма налични данни за оператора",
  byReportCount: " По брой доклади",
  topOperators: " Топ оператори",
  topExcavators: " Топ машини",
  refresh: " Опресняване",
  searchExcavators: " Търсене на машини",
  maintenanceReport: " Доклад за поддръжка",
  created: " Създаден",
  createdAt: " Създаден на",
  signReport: " Подписване на доклад",
  signReportDescription: " Bitte unterschreiben Sie den Bericht, um ihn zu genehmigen. Ihre Unterschrift wird zur Genehmigung des Berichts verwendet.",
  signatureArea: " Зона за подпис",
  signAndApprove: " Подписване и одобряване",
  signingAs: " Подписвате като",
  useProfileSignature: " Използване на подпис от профила",
  "Invalid Date": " Невалидна дата",
  recentBetriebstagebuch: " Скорошни записи в дневника",
  details: " Детайли",
  equipmentAndPersonnel: " Оборудване и персонал",
  Berichtsdetails: " Berichtsdetails", // Keep German key
  lastLogin: " Последен вход",
  searchByNameEmailRole: " Търсене по име, имейл или роля",
  adminFullAccess: " Администратор - Пълен достъп",
  managerAccess: " Мениджър - Ограничен достъп",
  operatorAccess: " Оператор - Ограничен достъп",
  newPasswordLeaveBlank: " Нова парола (оставете празно, за да запазите текущата)",
  enterFullName: " Въведете пълно име",
  noReportsFound: " Няма намерени доклади",
  noReportsCreatedYet: " Все още няма създадени доклади",
  next: " Следващ",
  excavatorList: " Списък с машини",
  approvalConfirmation: " Сигурни ли сте, че искате да одобрите този доклад?",
  clearPad: " Изчистване на подписа",
  approve: " Одобряване",
  setOperational: " Маркиране като в експлоатация",
  assignOperator: " Назначаване на оператор",
  scheduleMaintenance: " Планиране на поддръжка",
  betriebstagebuchQuickView: " Бърз преглед на дневника",
  entryId: " ИД на запис",
  yourSignature: " Вашият подпис",
  security: " Сигурност",
  signatureDescription: " Моля, добавете вашия подпис, за да одобрите докладите.",
  signatureTips: " Съвети за подпис: Използвайте писалката, за да нарисувате подписа си. Кликнете върху 'Запазване на подписа', за да запазите.",
  signatureTip1: " Добавяне на подпис: Използвайте писалката, за да нарисувате подписа си.",
  signatureTip2: " Кликнете върху 'Запазване на подписа', за да запазите подписа си.",
  signatureTip3: " Кликнете върху 'Изчистване на подписа', за да премахнете подписа си.",
  signatureTip4: " Кликнете върху 'Запазване на подписа', за да запазите подписа си.",
  currentSignature: " Текущ подпис",
  emailCannotBeChanged: " Имейл адресът не може да бъде променян",
  fullName: " Пълно име",
  memberSince: " Член от",
  systemDescription: " Das Wartungsberichtsystem ist eine webbasierte Anwendung...",
  registerToJoinDescription: " Registrieren Sie sich, um dem Wartungsberichtsystem beizutreten...",
  registerToJoin: " Регистрирайте се, за да се присъедините към системата за доклади за поддръжка",
  forgotPassword: " Забравена парола?",
  address: " Herzbergstraße 19-21, 10365 Berlin, Deutschland",
  contactUs: " Свържете се с нас",
  termsOfService: " Условия за ползване",
  privacyPolicy: " Политика за поверителност",
  footerDescription: " Навсякъде по всяко време",
  specialChecks: " Специални проверки",
  addSpecialCheck: " Добавяне на специална проверка",
  "reports.totalReports": " Общо доклади",
  "reports.statistics": " Статистика на докладите",
  "reports.thisMonth": " Месечни доклади",
  "reports.pending": " Чакащи доклади",
  "reports.completed": " Завършени доклади",
  noGeneralNotesProvided: " Няма предоставени общи бележки",
  close: " Затваряне",
  serviceDate: " Дата на доклада",
  size: " Размер",
  machineType: " Тип машина",
  Wheeled: " Колесен",
  viewFullDetails: " Преглед на пълните детайли",
  downloadPdf: " Изтегляне на PDF",

  // Excavator table headers
  manufacturer: "Производител",
  model: "Модел",
  serialNumber: "Сериен Номер",
  year: "Година",
  status: "Статус",
  lastMaintenance: "Последна Поддръжка",
  actions: "Действия",

  // Report table headers
  reportId: "ИД на Доклад",
  excavator: "Машина",
  type: "Тип",
  date: "Дата",
  technician: "Оператор", // Updated from "Техник" to "Оператор"
  report: "Доклад",
  machine: "Машина",

  // Actions
  view: "Преглед",
  edit: "Редактиране",
  delete: "Изтриване",
  add: "Добавяне",
  addExcavator: "Добавяне на Машина",
  addReport: "Добавяне на Доклад",

  // Status options
  operational: "В експлоатация",
  maintenance: "В поддръжка",
  repair: "В ремонт",
  outOfService: "Извън експлоатация",
  signed: "Подписан",
  unsigned: "Неподписан",
  approved: "Одобрен",
  pendingApproval: "Чакащ одобрение",
  completed: "Завършен",

  // Form labels
  save: "Запазване",
  cancel: "Отказ",
  uploadImage: "Качване на Изображение",

  // Other common text
  confirmDelete: "Сигурни ли сте, че искате да изтриете този елемент?",
  noDataAvailable: "Няма налични данни",
  loading: "Зареждане...",
  error: "Грешка",
  success: "Успех",

  // 404 Page
  pageNotFound: "Страницата не е намерена",
  pageNotFoundMessage:
    "Страницата, която търсите, може да е премахната, преименувана или временно недостъпна.",
  goToDashboard: "Към таблото",
  goBack: "Назад",

  // Footer
  version: "Версия",

  // User Management
  userManagement: "Управление на потребители",
  createUser: "Създаване на потребител",
  editUser: "Редактиране на потребител",
  deleteUser: "Изтриване на потребител",
  name: "Име",
  email: "Имейл",
  role: "Роля",
  password: "Парола",
  confirmPassword: "Потвърждаване на парола",
  administrator: "Администратор",
  manager: "Мениджър",
  operator: "Оператор",

  // Profile page
  changePassword: "Промяна на парола",
  currentPassword: "Текуща парола",
  newPassword: "Нова парола",
  updatePassword: "Актуализиране на парола",
  userProfile: "Потребителски профил",
  personalDetails: "Лични данни",
  department: "Отдел",
  phoneNumber: "Телефонен номер",
  signature: "Подпис",
  saveChanges: "Запазване на промените",
  uploadProfileImage: "Качване на профилна снимка",

  // Login/Register
  loginToAccess: "Влезте за достъп до системата",
  createAccount: "Създаване на акаунт",
  alreadyHaveAccount: "Вече имате акаунт?",
  dontHaveAccount: "Нямате акаунт?",
  enterEmail: "Въведете вашия имейл",
  enterPassword: "Въведете вашата парола",
  enterName: "Въведете вашето име",
  confirmYourPassword: "Потвърдете вашата парола",
  or: "ИЛИ",
  emailRequired: "Имейлът е задължителен",
  pleaseEnterValidEmail: "Моля, въведете валиден имейл",
  passwordRequired: "Паролата е задължителна",
  passwordMinLength: "Паролата трябва да бъде поне 6 символа",
  loggingIn: "Влизане...",

  // Dashboard
  welcome: "Добре дошли отново",
  viewProfile: "Преглед на профила",
  quickActions: "Бързи действия",
  recentActivity: "Последна активност",
  maintenanceStatus: "Статус на поддръжка",
  monthlyReports: "Месечни доклади",
  statistics: "Статистика",
  createReport: "Създаване на доклад",
  pendingWork: "Предстояща работа",
  viewReportStatistics: "Преглед на статистиката на докладите",
  totalExcavators: "Общ брой машини",
  activeExcavators: "Активни машини",
  totalReports: "Общо доклади",
  pendingReports: "Чакащи доклади",
  loadingDashboard: "Зареждане на данните на таблото...",
  failedToLoadDashboard:
    "Неуспешно зареждане на данните на таблото. Моля, опитайте отново.",
  viewAll: "Преглед на всички",

  // Filter and Search
  filter: "Филтър",
  search: "Търсене",
  searchPlaceholder: "Търсене по модел, производител, сериен номер...",
  clear: "Изчистване",
  all: "Всички",
  upToDate: "Актуално",
  maintenanceDue: "Предстояща поддръжка",
  overdue: "Просрочено",
  resetFilters: "Нулиране на филтри",
  applyFilters: "Прилагане на филтри",
  never: "Никога",

  // Report Detail Page
  loadingReport: "Зареждане на доклад...",
  failedToLoadReport: "Неуспешно зареждане на доклада",
  errorDownloadingPDF: "Грешка при изтегляне на PDF",
  signatureRequired: "Изисква се подпис",
  nameRequired: "Изисква се име",
  reviewerName: "Име на проверяващия",
  clearSignature: "Изчистване на подписа",
  saveSignature: "Запазване на подписа",
  enterYourName: "Въведете вашето име",
  onlyManagersCanApprove: "Само мениджъри могат да одобряват доклади",
  downloading: "Изтегляне...",
  downloadPDF: "Изтегляне на PDF",
  approveReport: "Одобряване на доклада",
  editReport: "Редактиране на доклада",
  maintenanceReportDetails: "Детайли на доклада за поддръжка",
  back: "Назад",
  reportNotFound: "Докладът не е намерен",
  reportNotFoundMessage: "Търсеният доклад не може да бъде намерен",
  approveMaintenanceReport: "Одобряване на доклад за поддръжка",
  managerName: "Име на мениджъра",
  createdOn: "Създаден на",
  excavatorInformation: "Информация за машината",
  unknown: "Неизвестно",
  "n/a": "Не е посочено",
  serviceInformation: "Информация за обслужването",
  serviceType: "Тип на обслужване",
  equipmentHours: "Работни часове",
  location: "Местоположение",
  routine: "Рутинно",
  exterior: "Външно",
  interior: "Вътрешно",
  engine: "Двигател",
  cleaning: "Почистване",
  notes: "Бележки",
  checklist: "Чеклист",
  item: "Елемент",
  additionalNotes: "Допълнителни бележки",
  noAdditionalNotesProvided: "Не са предоставени допълнителни бележки",
  signatures: "Подписи",
  technicianSignature: "Подпис на оператора", // Updated from "Подпис на техника" to "Подпис на оператора"
  noSignatureAvailable: "Няма наличен подпис",
  signedBy: "Подписан от",
  managerApproval: "Одобрение от мениджъра",
  approvedBy: "Одобрен от",
  thisReportIsWaitingForYourApproval: "Този доклад очаква вашето одобрение",
  pendingManagerApproval: "Чака одобрение от мениджър",
  signAndApproveNow: "Подпишете и одобрете сега",
  processing: "Обработка...",
  sign: "Подпис",
  noInspectionDataAvailableFor: "Няма налични данни за инспекция за",
  notSpecified: "Не е посочено",
  tryAgain: "Опитайте отново",
  generalInformation: "Обща информация",
  technicalDetails: "Технически детайли",
  maintenanceChecklist: "Чеклист за поддръжка",
  operatingHours: "Работни часове",
  hours: "часа",
  maintenanceType: "Тип на поддръжка",
  reviewedBy: "Прегледан от",
  signedDate: "Дата на подписване",
  hydraulic: "Хидравлика",
  routineMaintenance: "Рутинна поддръжка",
  failedToApproveReport: "Неуспешно одобрение на доклада",
  reportApprovedSuccessfully: "Докладът е успешно одобрен",
  reportsAvailable: "налични доклади",
  bulkSignErrorTitle: "Грешка при групово подписване",
  currentUserDataMissingError: "Липсват данни за текущия потребител за групово подписване.",

  // Create Report Page
  createMaintenanceReport: "Създаване на доклад за поддръжка",
  selectExcavator: "Избор на машина",
  pleaseSelectExcavator: "Моля, изберете машина",
  reportDetails: "Детайли на доклада",
  maintenanceDate: "Дата на поддръжка",
  nextMaintenanceDate: "Следваща дата за поддръжка",
  technicianName: "Име на оператор",
  inspectionChecklist: "Списък за проверка",
  exteriorChecks: "Външна проверка",
  interiorChecks: "Вътрешна проверка",
  engineChecks: "Проверка на двигателя",
  hydraulicChecks: "Проверка на хидравликата",
  notApplicable: "Не е приложимо",
  notDone: "Не е извършено",
  additionalComments: "Допълнителни коментари",
  submitReport: "Изпращане на доклада",
  pleaseAddSignature: "Моля, добавете вашия подпис",
  pleaseSelectDate: "Моля, изберете дата",
  reportSubmittedSuccessfully: "Докладът е изпратен успешно",
  failedToSubmitReport: "Неуспешно изпращане на доклада",
  submitting: "Изпращане...",

  // Chart labels
  chartReportsByMonth: "Доклади по месеци",
  chartNumberOfReports: "Брой доклади",
  itemsCompleted: " Завършени елементи",
  completionStatus: " Статус на завършване",
  checksCompleted: " Завършени проверки",
  notesAdded: " Добавени бележки",

  // Report checklist items
  chassis: " Шаси",
  boom: " Стрела",
  bucket: " Кофа",
  hydraulics: " Хидравлика",
  mirrors: " Огледала",
  windows: " Прозорци",
  cameras: " Камери",
  lights: " Светлини",
  wipers: " Чистачки",
  lubricationSystem: " Система за смазване",
  seat: " Седалка",
  electronics: " Електроника",
  heating: " Отопление",
  airConditioning: " Климатик",
  joystick: " Джойстик",
  display: " Дисплей",
  controls: " Управление",
  parkingBrake: " Ръчна спирачка",
  engineOil: " Моторно масло",
  hydraulicOil: " Хидравлично масло",
  coolant: " Охлаждаща течност",
  windshieldWasher: " Течност за чистачки",
  transmissionOil: " Трансмисионно масло",
  fuelFilter: " Горивен филтър",
  airFilter: " Въздушен филтър",
  washed: " Измито",
  windowsCleaned: " Почистени прозорци",
  mirrorsCleaned: " Почистени огледала",
  interiorWindowsCleaned: " Почистени вътрешни прозорци",
  interiorWiped: " Избърсан интериор",
  interiorVacuumed: " Почистен с прахосмукачка интериор",
  fuelLevel: " Ниво на гориво",
  startDate: " Начална дата",
  endDate: " Крайна дата",
  nextInspectionDate: " Следваща дата на инспекция",

  // Betriebstagebuch (Operating Journal)
  betriebstagebuch: "Дневник на операциите",
  betriebstagebuchList: "Списък на дневниците",
  createBetriebstagebuch: "Създаване на запис в дневника",
  editBetriebstagebuch: "Редактиране на запис в дневника",
  viewBetriebstagebuch: "Преглед на запис в дневника",
  betriebstagebuchDetails: "Детайли на дневника",
  conveyorChecks: "Проверки на конвейерите",
  conveyorName: "Име на конвейер",
  functional: "Функционален",
  notFunctional: "Не функционира",
  conveyorNotes: "Бележки за този конвейер",
  generalNotes: "Общи бележки",
  addConveyor: "Добавяне на конвейер",
  removeConveyor: "Премахване",
  noConveyorsAdded: "Все още няма добавени конвейери",
  entryDate: "Дата на записа",
  createdBy: "Създаден от",
  creator: "Създател",
  reviewer: "Рецензент",
  reviewerSignature: "Подпис на рецензента",
  creatorSignature: "Подпис на създателя",
  betriebstagebuchCreated: "Записът в дневника е успешно създаден",
  betriebstagebuchUpdated: "Записът в дневника е успешно актуализиран",
  betriebstagebuchApproved: "Записът в дневника е успешно одобрен",
  betriebstagebuchDeleted: "Записът в дневника е успешно изтрит",
  downloadBetriebstagebuchPDF: "Изтегляне на PDF",
  approveBetriebstagebuch: "Одобряване на запис",
  recyclingCenter: "Център за рециклиране",
  sortingMachine: "Сортировъчна машина",
  allConveyorsMustBeNamed: "Всички конвейери трябва да имат име",
  errorSavingEntry: "Грешка при запазване на записа",
  quickView: " Бърз преглед",
  tryChangingFilters: " Опитайте да промените филтрите",
  conveyorChecksSummary: " Zusammenfassung der Förderband-Prüfungen",
  noSpecialChecksRecorded: " Няма записани специални проверки",
  backToList: " Обратно към списъка",
  reviewedOn: " Прегледан на",
  apply: " Прилагане",
  reset: " Нулиране",
  rowsPerPage: " Редове на страница",
  of: " от",
  searchExcavatorsPlaceholder: " Търсене по модел, производител, сериен номер или тип...",
  searchBy: " Търсене по",
  noMatchingResults: " Няма намерени съвпадения",
  clearSearch: " Изчистване на търсенето",
  batchGenerateBetriebstagebuch: " Групово генериране на дневници",
  createMultipleEntries: " Създаване на няколко записа наведнъж",
  dateRange: " Период",
  addNewUser: " Добавяне на нов потребител",
  nextMaintenance: " Следваща поддръжка",
  daysInRange: " Дни в периода",
  entriesToBeGenerated: " Записи за генериране",
  allEntriesWillHaveYourSignature: " Всички записи ще имат вашия подпис",
  generateEntries: " Генериране на записи",
  generating: " Генериране...",
  generatedEntries: " Генерирани записи",
  betriebstagebuchEntriesGenerated: " Записите в дневника са успешно генерирани",
  errorGeneratingEntries: " Грешка при генериране на записите в дневника",
  dayOfWeek: " Ден от седмицата",
  pleaseSelectDateRange: " Моля, изберете период",
  endDateMustBeAfterStartDate: " Крайната дата трябва да е след началната",
  onlyAdminsCanBatchGenerate: " Само администратори могат да генерират групово дневници",
  allConveyorsWillBeAddedToEachEntry: " Всички конвейери ще бъдат добавени към всеки запис",
  weekendsAreExcluded: " Почивните дни (събота и неделя) се изключват автоматично",
  preview: " Преглед",
  allSpecialChecksMustBeNamed: " Всички специални проверки трябва да имат име",
  specialCheckNotes: " Бележки за тази проверка",
  checkName: " Име на проверката",
  notCompleted: " Не е завършено",

  // Conveyor Names (kept the same as in German)
  AT: "AT",
  Steigband: "Steigband",
  Trommel: "Trommel",
  HeckBand: "HeckBand",
  SortierBand: "SortierBand",
  MagnetSortierHaus: "MagnetSortierHaus",
  MagnetHalle: "MagnetHalle",
  SeitenBand: "SeitenBand",
  Zuführband: "Zuführband",
  TrommelWindsichter: "TrommelWindsichter",
  SpeedBand: "SpeedBand",
  Airlift: "Airlift",
  Airwheel: "Airwheel",
  Ventilator: "Ventilator",

  // Machine Overview/Details
  overview: " Преглед",
  description: " Описание",
  daysUntilDue: " Дни до падежа",
  days: " Дни",
  upcomingMaintenances: " Предстоящи поддръжки",
  updateHours: " Актуализиране на часове",
  updateOperatingHours: " Актуализиране на работни часове",
  featureComingSoon: " Функцията идва скоро",
  uvvStatus: " UVV статус",
  nextInspection: " Следваща инспекция",
  noDescription: " Няма налично описание",
  noNotes: " Няма налични бележки",
  noData: " Няма налични данни",
  gallery: " Галерия",
  attachments: " Прикачени файлове",
  comments: " Коментари",
  relatedEquipment: " Свързано оборудване",
  select: " Избор",
  assign: " Назначаване",
  schedule: " Планиране",

  // Missing placeholders and fallback strings
  appName: "FleetPilot",
  shiftStartPlaceholder: "напр. Ранна смяна, 06:00",
  shiftEndPlaceholder: "напр. Късна смяна, 14:00",
  weatherPlaceholder: "напр. Слънчево, лек вятър",
  temperaturePlaceholder: "напр. 15",
  fuelLevelPlaceholder: "напр. 75%",
  foreignMaterialControl: "Контрол на собствени, чужди и доставки",
  noIncidents: "Няма инциденти",
  fetchingWeatherData: "Зареждане на метеорологични данни...",
  sunny: "Слънчево",

  // Additional missing translations from form validations and operations
  signatureCannotBeEmpty: "Подписът не може да бъде празен",
  noProfileSignatureAvailable: "Няма наличен подпис в профила",
  managersOnlyCanCreateBTB: "Само мениджърите могат да създават записи в дневника",
  pleaseCorrectFormErrors: "Моля, коригирайте грешките във формуляра",
  errorFetchingEntry: "Грешка при извличане на записа",
  loadingEntry: "Зареждане на запис...",
  accessDenied: "Достъпът е отказан",
  saving: "Запазване...",
  saved: "Запазено",
  updateEntry: "Актуализиране на запис",
  saveEntry: "Запазване на запис",
  entryUpdatedSuccess: "Записът е успешно актуализиран",
  entryCreatedSuccess: "Записът е успешно създаден",
  general: "Общо",
  conveyorNameRequired: "Името на конвейера е задължително",
  checkNameRequired: "Името на проверката е задължително",
  dateIsRequired: "Датата е задължителна",
  signatureIsRequired: "Подписът е задължителен",

  // User Management missing translations
  errorFetchingUsers: "Грешка при извличане на потребители",
  nameIsRequired: "Името е задължително",
  emailIsRequired: "Имейлът е задължителен",
  invalidEmailFormat: "Невалиден формат на имейл",
  passwordIsRequiredForNewUser: "Паролата е задължителна за нови потребители",
  userCreatedSuccessfully: "Потребителят е успешно създаден",
  userUpdatedSuccessfully: "Потребителят е успешно актуализиран",
  errorSavingUser: "Грешка при запазване на потребител",
  userDeletedSuccessfully: "Потребителят е успешно изтрит",
  errorDeletingUser: "Грешка при изтриване на потребител",
  manageUsers: "Управление на потребители",
  searchUsers: "Търсене на потребители",
  allRoles: "Всички роли",
  noMatchingUsers: "Няма намерени съвпадащи потребители",
  noUsersFound: "Няма намерени потребители",
  createNewUser: "Създаване на нов потребител",
  newPasswordOptional: "Нова парола (по избор)",
  leaveBlankNoChange: "Оставете празно, за да запазите текущата парола",
  confirmUserDeletion: "Потвърждение за изтриване на потребител",
  areYouSureDeleteUser: "Сигурни ли сте, че искате да изтриете {{name}}?",
  thisActionCannotBeUndone: "Това действие не може да бъде отменено.",

  // Statistics page missing translations
  errorFetchingStats: "Грешка при извличане на статистики",
  noDataToExport: "Няма данни за експортиране",
  csvExportedSuccessfully: "CSV е успешно експортиран",
  statisticsAndReports: "Статистики и доклади",
  applicationStatistics: "Статистики на приложението",
  printPage: "Печат на страница",
  reportType: "Тип доклад",
  allExcavators: "Всички машини",
  allTypes: "Всички типове",
  reportStatusDistribution: "Разпределение на статуса на докладите",
  machineSpecificStatsComingSoon: "Статистики за конкретни машини идват скоро",
  personnelSpecificStatsComingSoon: "Статистики за персонала идват скоро",
  betriebstagebuchTotal: "Общо дневници",

  // Batch generation missing translations
  configurationTemplate: "Шаблон за конфигурация",
  dateRangeForGeneration: "Период за генериране",
  weekendsAreExcludedInfo: "Уикендите (събота и неделя) се изключват автоматично",
  dailyEntryTemplate: "Шаблон за дневен запис",
  defaultConveyorChecks: "Стандартни проверки на конвейери",
  allConveyorsWillBeAddedInfo: "Всички конвейери ще бъдат добавени към всеки запис",
  signatureRequiredForGeneration: "Подпис е необходим за генериране",
  noWorkdaysInRange: "Няма работни дни в диапазона",
  adminsOnlyCanAccessBatch: "Само администратори могат да достъпят групово генериране",

  // Footer missing translations
  allRightsReserved: "Всички права запазени.",

  // Additional component translations
  maker: "Производител",
  selectFile: "Избор на файл",
  removeImage: "Премахване на изображение",
};

export default translations;
